// @flow
import * as React from 'react';
import type { HOC as ElementType } from 'recompose';

export const withAnimate = (Comp: ElementType) => (props: any) => (
  <Comp {...props}>
    <animateTransform
      attributeType="XML"
      attributeName="transform"
      type="rotate"
      from="0 24 24"
      to="360 24 24"
      dur="1.8s"
      repeatCount="indefinite"
    />
  </Comp>
);
